import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export default Container;
